import { ChargerLocationType } from "../../../__generated__/graphql-types";

import { FPADataQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_chargingData_ChargingData_chargers_Charger } from "../../../connected-components/hoc/query/__generated__/fpa-page-data.query";

export const calculateHoursPerWeekToCharge = (
  annualMileage: number | null,
  milesRangePerHourChargeTime?: number | null,
) => {
  if (!milesRangePerHourChargeTime || !annualMileage) {
    return null;
  }
  const weeklyMileage = annualMileage / 52;
  const hoursChargingAWeek = weeklyMileage / milesRangePerHourChargeTime;

  return Math.ceil(hoursChargingAWeek);
};

export const getFastestCharger = (
  chargers:
    | (FPADataQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_chargingData_ChargingData_chargers_Charger | null)[]
    | undefined,
) => {
  if (chargers && chargers?.length > 0) {
    // eslint-disable-next-line unicorn/no-array-reduce
    const fastCharger = chargers.reduce((prev, current) => {
      return !!prev?.milesRangePerHourChargeTime >
        !!current?.milesRangePerHourChargeTime
        ? prev
        : current;
    });
    return fastCharger;
  }
};

export const getDefaultChargingSpeed = (
  chargers: (FPADataQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_chargingData_ChargingData_chargers_Charger | null)[],
) => {
  if (chargers && chargers?.length > 0) {
    const sevenPointFourCharger = chargers.find((charger) => {
      if (charger?.description.includes("7.4 kW")) {
        return charger.description;
      }
      return;
    });
    if (sevenPointFourCharger) {
      return sevenPointFourCharger.description;
    }

    const fastestCharger = getFastestCharger(chargers);

    if (fastestCharger?.description) return fastestCharger.description;
  }
};

export const locationToggleOptions = (
  location: ChargerLocationType,
  hasPublicChargers: boolean,
  hasHomeChargers: boolean,
) => {
  return [
    {
      label: "Home",
      value: ChargerLocationType.HOME,
      selected: location === ChargerLocationType.HOME,
      disabled: !hasHomeChargers,
      "data-testid": "home-charging-toggle",
    },
    {
      label: "Public",
      value: ChargerLocationType.PUBLIC,
      selected: location === ChargerLocationType.PUBLIC,
      disabled: !hasPublicChargers,
      "data-testid": "public-charging-toggle",
    },
  ];
};
